import { render, staticRenderFns } from "./messagelist.vue?vue&type=template&id=aca87e76&"
import script from "./messagelist.vue?vue&type=script&lang=ts&"
export * from "./messagelist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aca87e76')) {
      api.createRecord('aca87e76', component.options)
    } else {
      api.reload('aca87e76', component.options)
    }
    module.hot.accept("./messagelist.vue?vue&type=template&id=aca87e76&", function () {
      api.rerender('aca87e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messagelist.vue"
export default component.exports